import Modal from 'tio-ui/components/modal';
import Footer from 'tio-ui/components/footer';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import Button from 'tio-ui/components/button';
import { on } from '@ember/modifier';
import type { ReadonlyTemplateFieldConfigAndValues } from '../../../utils/tuition-assistance/fields.ts';
import type TasFieldOptionModel from 'tio-data/models/tas-field-option';

export interface TuitionAssistanceProgramTemplateReviewRowReviewSignature {
  Args: {
    field: ReadonlyTemplateFieldConfigAndValues;
    fieldOptions?: TasFieldOptionModel[];
  };
}

export default class TuitionAssistanceProgramTemplateReviewRowReviewComponent extends Component<TuitionAssistanceProgramTemplateReviewRowReviewSignature> {
  @tracked isShowingOptionsDialog = false;

  isTrueOrFalse(value: boolean | undefined) {
    return value ? 'Yes' : 'No';
  }

  toggleOptionsDialog = () => {
    this.isShowingOptionsDialog = !this.isShowingOptionsDialog;
  };

  <template>
    <div class="col-start-1 col-span-1">
      {{@field.label}}
    </div>
    <div class="col-span-1 justify-self-center">
      {{this.isTrueOrFalse @field.visible}}
    </div>
    <div class="col-span-1 justify-self-center">
      {{this.isTrueOrFalse @field.required}}
    </div>
    <div class="col-span-1 justify-self-start">
      <div class="inline">{{this.isTrueOrFalse @field.value_as_field_option}}</div>
      {{#if @field.value_as_field_option}}
        <Button
          @appearance="minimal"
          @intent="primary"
          {{on "click" this.toggleOptionsDialog}}
          class="text-sm"
        >
          {{t "common.view_options"}}
        </Button>
      {{/if}}
    </div>

    {{#if this.isShowingOptionsDialog}}
      <Modal
        @isOpen={{true}}
        @onClose={{this.toggleOptionsDialog}}
        class="min-h-64"
        @size="xl"
        @ariaLabel={{t "common.aria_labels.field_options"}}
      >
        <:header>{{@field.label}}</:header>
        <:body>
          <ol class="list-disc p-4">
            {{#each @fieldOptions as |fieldOption|}}
              {{! TODO: Lots to be desired in terms of display here. For now, just show the value. }}
              <li class="mb-2">{{fieldOption.value}}</li>
            {{/each}}
          </ol>
        </:body>
        <:footer>
          <Footer @isRunning={{false}} @onSubmit={{this.toggleOptionsDialog}} />
        </:footer>
      </Modal>
    {{/if}}
  </template>
}
